<template>
  <div>
    <v-container>
      <v-row class="" justify="center">
        <v-col class="col-auto my-0 py-0">
          <div class="item-condition" v-for="key in opt[0]">
            <v-checkbox
              v-model="目前狀態[key]"
              :label="`${mapping(key)}。`"
              hide-details
              @change="$emit(`update`)"
            ></v-checkbox>
          </div>
        </v-col>
        <v-col class="col-auto my-0 py-0">
          <div class="item-condition" v-for="key in opt[1]">
            <v-checkbox
              v-model="目前狀態[key]"
              :label="`${mapping(key)}。`"
              hide-details
              @change="$emit(`update`)"
            ></v-checkbox>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import util from "@/mixins/util";
export default {
  name: "QuestionContent",
  props: ["valid", "person", "問卷", "目前狀態"],
  mixins: [util],
  data: () => ({
    opt: [
      [
        "我目前有嚼食檳榔的習慣",
        "我過去曾經有嚼食檳榔的習慣",
        "我目前有吸菸的習慣",
        "我過去曾經有吸菸的習慣",
        "我有肺癌家族史",
      ],
      [
        "我有大腸癌病史",
        "我有大腸癌家族史",
        "我曾經有過性行為",
        "我目前懷孕中",
        "我有乳癌病史或乳癌家族史",
      ],
    ],
  }),
  created() {
    if (this.性別 == "男") {
      this.opt[1].pop();
      this.opt[1].pop();
    }
  },
  methods: {
    mapping(key) {
      switch (key) {
        case "我有乳癌病史或乳癌家族史":
          return `${key}(母親、姊妹、女兒、祖母、外祖母)`;
          break;
        case "我有大腸癌家族史":
        case "我有肺癌家族史":
          return `${key}(父母、兄弟姊妹、子女)`;
          break;
        default:
          return key;
      }
    },
  },
  watch: {
    "目前狀態.我目前有嚼食檳榔的習慣"(val) {
      if (val) {
        this.目前狀態.我過去曾經有嚼食檳榔的習慣 = false;
      }
    },
    "目前狀態.我過去曾經有嚼食檳榔的習慣"(val) {
      if (val) {
        this.目前狀態.我目前有嚼食檳榔的習慣 = false;
      }
    },
    "目前狀態.我目前有吸菸的習慣"(val) {
      if (val) {
        this.目前狀態.我過去曾經有吸菸的習慣 = false;
      }
    },
    "目前狀態.我過去曾經有吸菸的習慣"(val) {
      if (val) {
        this.目前狀態.我目前有吸菸的習慣 = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item-condition {
  width: 280px;
}

.v-label {
  display: block !important;
}
</style>
